"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GENERAL = void 0;
var GENERAL = {
  INPUT__SEARCH: 'products-input-search',
  BUTTON__SUPPLIER_FILTER: 'products-button-supplierFilter',
  BUTTON__CATEGORY_FILTER: 'products-button-categoryFilter'
};
exports.GENERAL = GENERAL;